import { createContext } from 'react'

const BotContext = createContext({})

export const BotProvider = BotContext.Provider
export const BotConsumer = BotContext.Consumer
export default BotContext
